import {
  AttributionInsights,
  exampleAttributionInsight,
  HourlyAttributionRows,
} from './AttributionInsights';

export interface HourlyAttributionInsights extends AttributionInsights {
  hourWindow: string; // '1:00 PM - 2:00 PM'
}

export const exampleHourlyAttributionInsight: HourlyAttributionInsights = {
  ...exampleAttributionInsight,
  hourWindow: '1:00 PM - 2:00 PM',
};

export const hourlyAttributionBreakdown: HourlyAttributionRows = {
  rows: [exampleHourlyAttributionInsight],
  breakdownType: 'Hourly',
};
